import Vue from 'vue';

import { SLOT_INTERVAL_MS } from "../../../constants_calendar";

const state = {
  currentlyBooking: false,

  /* contains user's selection session data. For each session, custom rematch, custom worktype, activity etc */
  selectionSessionData: {},
  /* Guaranteed to be sorted from nearest to furthest. Array of dateTimeMS of selected slots */
  selectedDateTimes: [],
};

const getters = {
  getSelectionData: (state) => (dateTimeMS) => state.selectionSessionData[dateTimeMS],
  currentlyBooking: (state) => state.currentlyBooking,
};

const mutations = {

  SET_CURRENTLY_BOOKING(state, newState) {
    state.currentlyBooking = newState;
  },

  /**
   * Adds to the selectedDateTimes array such that the array remains sorted
   * @param {
   *  dateTimeMS: {Number},
   *  partner: {
   *    metadata: {Object}
   *    preferences: {Array}
   *    session: {Object}
   *  },
   *  currentUserSession: {Object},
   *  length: {Number}
   * } payload -- selection data
   */
  SELECT_SLOT_TO_BOOK(state, payload) {
    const slotDateTimeMS = payload.dateTimeMS;
    let array = state.selectedDateTimes;
    let right = array.length;
    let left = 0;
    let idx;
    // binary search, not sure if necessary, maybe just arr.sort is just as fast + not sure how important this fastness even is here
    while (left < right) {
      idx = Math.floor((right+left)/2);
      if (array[idx] < slotDateTimeMS) {
        left = idx+1;
      } else {
        right = idx;
      }
    }
    console.log("here2,left: ", left);
    state.selectedDateTimes.splice(left, 0, slotDateTimeMS);
    
    if (state.selectedDateTimes.length > left+1) {
      if (state.selectedDateTimes[left+1] === slotDateTimeMS) {
        state.selectedDateTimes.splice(left+1, 1);
      }
    }

    Vue.set(state.selectionSessionData, slotDateTimeMS, payload);
  },

  /**
   * Removes one datetime from the selection
   * @param {
   *  index: {Number} index where the canceled datetime was 
   *  dateTimeMS: {Number} the datetime to cancel 
   * } payload
   */
  CANCEL_SLOT_TO_BOOK(state, payload) {
    Vue.delete(state.selectionSessionData, payload.dateTimeMS);
    state.selectedDateTimes.splice(payload.index, 1);
  },
  /**
   * Updates one field in one selection. 
   * @param {
   *  dateTimeMS: {Number},
   *  field: {String},
   *  newValue: {any}
   * } payload the update data. 
   */
  SET_SELECTION_FIELD(state, payload) {
    console.log("setting selection field: ", state.selectionSessionData[payload.dateTimeMS].currentUserSession)
    console.log("setting selection field: ", payload)
    state.selectionSessionData[payload.dateTimeMS].currentUserSession[payload.field] = payload.newValue;
  },

  SWAP_SELECTION_PARTNER(state, payload) {
    const newPartnerData = payload.partner;
    const dateTimeMS = payload.dateTimeMS;
    const selection = state.selectionSessionData[dateTimeMS];
    // selection = Object.assign({}, selection, { partner: newPartnerData });
    Vue.set(selection, "partner", newPartnerData);
  }

  
  
};

const actions = {
  setCurrentlyBooking(state, newState) {
    state.commit("SET_CURRENTLY_BOOKING", newState);
  },

  swapSelectionPartner({commit, rootGetters}, swapData) {
    const dateTimeMS = swapData.dateTimeMS;
    const partnerID = swapData.partnerID;
    const sessionsForSlot = rootGetters["matchPool/getUserSessionsForSlot"](dateTimeMS);

    let partnerSession = null;
    for (var i = 0; i<sessionsForSlot.length; i++) {
      let session = sessionsForSlot[i];
      if (session.matchableID == partnerID) {
        partnerSession = session;
        break;
      }
    }

    
    let partner = null;
    if (partnerID) {
      const partnerData = rootGetters["calendarUsers/getUserMatchingData"](partnerID);
      if (partnerData && partnerSession) {
        partnerData.session = partnerSession;
        partner = partnerData;
      }
    }

    swapData.partner = partner;
    commit("SWAP_SELECTION_PARTNER", swapData);
  },

  /**
   * Used in UnmatchedPerson, SlotHoverEmpty. Selects previously unselected slot
   * @param {Number/String} dateTimeMS 
   */
  async selectSlot({commit, dispatch, rootGetters}, dateTimeMS) {

    const partnerID = rootGetters["matchPool/getBestMatchID"](dateTimeMS);
    console.log("@selectSlot: best match ID: ", partnerID);
    if (partnerID) {
      await dispatch("matchPool/setPartnerAsSelected", {
        dateTimeMS,
        partnerID,
      }, {root: true});
    }
    const partnerSession = rootGetters["matchPool/getBestMatchSession"](dateTimeMS);
    
    let partner = null;
    if (partnerID) {
      const partnerData = rootGetters["calendarUsers/getUserMatchingData"](partnerID);
      if (partnerData && partnerSession) {
        partnerData.session = partnerSession;
        partner = partnerData;
      }
    }
    
    const currentUserSession = {
      rematch: rootGetters["calendar/getDefaultRematch"],
    };

    /* Adding data to Vuex */ // TODO
    const selectionData = {
      dateTimeMS,
      /* currently selected partner's data */
      partner,
      /* current user session data */
      currentUserSession,
      length: 50,
    };
    
    
    console.log("@selectSlot selectionData: ", selectionData);
    dispatch("calendar/setOneSlotFieldStatus", {
      dateTimeMS,
      field: "isSelected",
      value: true
    }, { root: true });

    /* Updating selecting availability */
    let dateTimeMSArray = [];
    for (let i=-3; i<=3; i++) {
      dateTimeMSArray.push(dateTimeMS + i*SLOT_INTERVAL_MS);
    } 
    dispatch("calendar/setSlotArrayFieldStatus", {
      dateTimeMSArray,
      field: "isAvailableForBooking",
      value: false
    }, { root: true });
    commit("SELECT_SLOT_TO_BOOK", selectionData);
  },

  /**
   * @param {
   *  dateTimeMS: {Number},
   *  field: {String},
   *  newValue
   * } payload the data to update
   */
  setSelectionField({state, commit}, payload) {
    if (Object.prototype.hasOwnProperty.call(state.selectionSessionData, payload.dateTimeMS)) {
      commit("SET_SELECTION_FIELD", payload);
    }
  },

  /**
   * Does not update availabilities, just cancels the slot
   * @return {Object} with two keys: previous and next. Values are dateTimeMS-s for 
   * slots that were also selected and were one before and one after the cancelled slot 
   */
  cancelSlot({state, commit, dispatch}, cancelledSlotDatetimeMS) {
    /* set slot as unselected */
    dispatch("calendar/setOneSlotFieldStatus", {
      dateTimeMS: cancelledSlotDatetimeMS,
      field: "isSelected",
      value: false
    }, { root: true });

    console.log("@cancelSlot", cancelledSlotDatetimeMS);
    console.log("@cancelSlot selectedDateTimes", state.selectedDateTimes);
    const index = state.selectedDateTimes.findIndex(
      (selection) => selection === cancelledSlotDatetimeMS
    );

    let returnObject = {
      previous: index !== 0 ? state.selectedDateTimes[index-1] : null,
      next: index+1 !== state.selectedDateTimes.length ? state.selectedDateTimes[index+1] : null
    };
    
    commit("CANCEL_SLOT_TO_BOOK", {dateTimeMS: cancelledSlotDatetimeMS, index});
    
    return returnObject;
  },

  /**
   * Public version for cancelling a slot. Calls cancelSlot to actually cancel and does a bunch of other stuff
   * Called after a slot at dateTimeMS was no longer selected
   * @param {Number} dateTimeMS 
   */
  async cancelSelection({dispatch}, dateTimeMS) {
    /* removing from selectedDateTimes array, returns the datetime selected before and datetime selected after */
    const {previous, next} = await dispatch("cancelSlot", dateTimeMS);
    /* updating selecting availability */
    /* TODO: this is just horrible */
    const upcoming = await dispatch("upcomingMatches/getMatchesInRange", {
      viewStartMS: dateTimeMS-3*SLOT_INTERVAL_MS, 
      viewEndMS: dateTimeMS+3*SLOT_INTERVAL_MS
    }, { root: true });
    let dateTimeMSArray = [];
    
    for (let i=-3; i<=3; i++) {
      const value = dateTimeMS + i*SLOT_INTERVAL_MS;
      if (previous && value <= previous + 3*SLOT_INTERVAL_MS) continue;
      if (next && value >= next - 3*SLOT_INTERVAL_MS) continue;
      let shouldAdd = true;
      for (let j=0; j<upcoming.length; j++) {
        if (
          upcoming[j]-3*SLOT_INTERVAL_MS <= value 
          && value <= upcoming[j]+3*SLOT_INTERVAL_MS
        ) {
          shouldAdd = false;
          break;
        }
      }
      if (shouldAdd) dateTimeMSArray.push(value);
    }

    dispatch("calendar/setSlotArrayFieldStatus", {
      dateTimeMSArray,
      field: "isAvailableForBooking",
      value: true
    }, { root: true });
  },

};

const booking = {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
};

export default booking;
